import {Inject, Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpHeaders
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiConfigService} from "../../../commons/angular/services/api-config.service";
import {resolveTenantId} from "../../../commons/utils/tenant.util";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(@Inject(ApiConfigService) private apiConfigService: ApiConfigService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let headers: HttpHeaders = req.headers.set('Accept', 'application/json');
    let authReq: HttpRequest<any>;

    // Get the current SiteId from the local store.
    const siteId: string = sessionStorage.getItem('currentSiteId');

    const adminToken: string = localStorage.getItem('admin_token') || localStorage.getItem('access_token');
    const tenant = resolveTenantId(window);

    if (adminToken) {
      const isConfigurationClient = req.url.includes('v2/iam/sso/configuration');
      if (!isConfigurationClient) {
        headers = headers.set('Authorization', `Bearer ${adminToken}`);
      }
    }

    if (!!tenant) {
      headers = headers.set('X-BRINGOZ-TENANT-ID', tenant);
    }

    // Clone the request and replace the original headers with
    // cloned headers, updated with the authorization.

    const isIcons = req.url.includes('/assets');
    const i18n = req.url.includes('/i18n');
    const auth0 = req.url.includes('auth0.com');

    if (isIcons || i18n || auth0) {
      authReq = req;
    } else {
      // Only send siteId when one is actually stored. HttpParams stringifies a null
      // value into the literal "siteId=null", which the API rejects with a 401.
      authReq = req.clone({
        url: `${this.apiConfigService.baseUrl}${req.url}`,
        headers,
        params: !!siteId ? req.params.set('siteId', siteId) : req.params
      });
    }

    // send cloned request with header to the next handler.
    return next.handle(authReq);
  }
}
